import {
  Button,
  Col,
  Form,
  InputNumber,
  Modal,
  Row,
  Space,
  Typography,
} from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, PermissionInfo, UserInfo } from "../../context";
import moment from "moment";

const DialogTeamLeaderUpdateCashCount = ({
  open,
  close,
  rerun,
  selectedData,
  //   totalSales,
}) => {
  const [oneThousandBill, setoneThousandBill] = useState(0);
  const [fiveHundredBill, setfiveHundredBill] = useState(0);
  const [twoHundredBill, settwoHundredBill] = useState(0);
  const [oneHundredBill, setoneHundredBill] = useState(0);
  const [fiftyBill, setfiftyBill] = useState(0);
  const [twentyBill, settwentyBill] = useState(0);
  const [twentyCoin, settwentyCoin] = useState(0);
  const [tenCoin, settenCoin] = useState(0);
  const [fiveCoin, setfiveCoin] = useState(0);
  const [oneCoin, setoneCoin] = useState(0);
  const [fiftyCentsCoin, setfiftyCentsCoin] = useState(0);
  const [twentyfiveCentsCoin, settwentyfiveCentsCoin] = useState(0);
  const [tenCentsCoin, settenCentsCoin] = useState(0);
  const [fiveCentsCoin, setfiveCentsCoin] = useState(0);
  const [oneCentCoin, setoneCentCoin] = useState(0);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const { permissionList } = useContext(PermissionInfo);
  const date_now = moment(`${moment().format("YYYY-MM-DDTHH:mm:ss.000000Z")}`)
    .utc()
    .format("YYYY-MM-DD");
  const [totalSales, setTotalSales] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);

  const time_now = moment(`${moment().format("YYYY-MM-DDTHH:mm:ss")}`).format(
    "HH:mm:ss"
  );

  const handleUpdatedADailyCashCount = (values) => {
    const formdata = new FormData();
    formdata.append("user", "team-leader");
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "merchant_user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append("id", selectedData !== null && selectedData.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    formdata.append("daily_sales", totalSales);
    formdata.append("daily_expense", totalExpense);
    formdata.append(
      "g_total",
      parseFloat(oneThousandBill) +
        parseFloat(fiveHundredBill) +
        parseFloat(twoHundredBill) +
        parseFloat(oneHundredBill) +
        parseFloat(fiftyBill) +
        parseFloat(twentyBill) +
        parseFloat(twentyCoin) +
        parseFloat(tenCoin) +
        parseFloat(fiveCoin) +
        parseFloat(oneCoin) +
        parseFloat(fiftyCentsCoin) +
        parseFloat(twentyfiveCentsCoin) +
        parseFloat(tenCentsCoin) +
        parseFloat(fiveCentsCoin) +
        parseFloat(oneCentCoin)
    );

    axios
      .post("user/merchant-employee/update/cash-count-daily", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated cash count successfully.");
          setTimeout(() => {
            close();
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const getDailySalesList = useCallback(() => {
    var date_from = "";
    var date_to = "";
    if (
      permissionList.data.merchant_info.operation_opens !== null &&
      permissionList.data.merchant_info.operation_closes !== null
    ) {
      if (
        permissionList.data.merchant_info.operation_closes <
        permissionList.data.merchant_info.operation_opens
      ) {
        if (time_now > permissionList.data.merchant_info.operation_opens) {
          date_from = moment(
            `${date_now}T${permissionList.data.merchant_info.operation_opens}`
          ).format("YYYY-MM-DDTHH:mm:ss");
          date_to = moment(
            `${date_now}T${permissionList.data.merchant_info.operation_closes}`
          )
            .add(1, "day")
            .format("YYYY-MM-DDTHH:mm:ss");
        } else {
          date_from = moment(
            `${date_now}T${permissionList.data.merchant_info.operation_opens}`
          )
            .subtract(1, "day")
            .format("YYYY-MM-DDTHH:mm:ss");
          date_to = moment(
            `${date_now}T${permissionList.data.merchant_info.operation_closes}`
          ).format("YYYY-MM-DDTHH:mm:ss");
        }
      } else {
        date_from = moment(
          `${date_now}T${permissionList.data.merchant_info.operation_opens}`
        ).format("YYYY-MM-DDTHH:mm:ss");
        date_to = moment(
          `${date_now}T${permissionList.data.merchant_info.operation_closes}`
        ).format("YYYY-MM-DDTHH:mm:ss");
      }
    } else {
      date_from = moment(`${date_now}T00:00:00`).format("YYYY-MM-DDTHH:mm:ss");
      date_to = moment(`${date_now}T23:59:00`).format("YYYY-MM-DDTHH:mm:ss");
    }

    var params = {
      user_id: selectedData.user_id,
      date_from,
      date_to,
    };

    axios
      .get("user/merchant-employee/get/daily-sales", { params })
      .then((response) => {
        setTotalSales(getTotalCost(response.data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [selectedData.user_id]);

  const getTotalCost = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseInt(data[i].quantity) * parseFloat(data[i].price);
    }
    return total;
  };

  const getExpenseSpecCashCount = useCallback(() => {
    var params = {
      cash_count_id: selectedData !== null && selectedData.id,
    };
    axios
      .get("user/merchant-employee/get/cash-count-expense", { params })
      .then((response) => {
        setTotalExpense(getTotalAmount(response.data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getTotalAmount = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseInt(data[i].amount) * 1;
    }
    return total;
  };

  useEffect(() => {
    getDailySalesList();
    getExpenseSpecCashCount();
  }, [getDailySalesList, getExpenseSpecCashCount]);

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      //   closable={false}
      footer={null}
      width={350}
      centered
    >
      <Form
        layout="vertical"
        name="update-cash-count"
        onFinish={handleUpdatedADailyCashCount}
        autoComplete="off"
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Row>
            <Col
              xs={24}
              style={{ borderBottom: "1px solid #e5e5e5", marginBottom: 10 }}
            >
              <Typography style={{ fontWeight: "bold", fontSize: 18 }}>
                PESO BILL
              </Typography>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_1000"
                  label="1000 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneThousandBill(value * 1000)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_500"
                  label="500 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiveHundredBill(value * 500)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_200"
                  label="200 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwoHundredBill(value * 200)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_100"
                  label="100 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneHundredBill(value * 100)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_50"
                  label="50 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiftyBill(value * 50)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_20"
                  label="20 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwentyBill(value * 20)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col
              xs={24}
              style={{ borderBottom: "1px solid #e5e5e5", marginBottom: 10 }}
            >
              <Typography style={{ fontWeight: "bold", fontSize: 18 }}>
                PESO COIN
              </Typography>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_20"
                  label="20 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwentyCoin(value * 20)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_10"
                  label="10 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settenCoin(value * 10)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_5"
                  label="5 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiveCoin(value * 5)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_1"
                  label="1 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneCoin(value * 1)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_50c"
                  label="50 Cents"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiftyCentsCoin(value * 0.5)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_25c"
                  label="25 Cents"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwentyfiveCentsCoin(value * 0.25)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_10c"
                  label="10 Cents"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settenCentsCoin(value * 0.1)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_5c"
                  label="5 Cents Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiveCentsCoin(value * 0.05)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_1c"
                  label="1 Cent Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneCentCoin(value * 0.01)}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border: "1px solid green",
            }}
          >
            <Typography style={{ fontSize: 22, fontWeight: "bold" }}>
              &#8369;
              {parseFloat(
                parseFloat(oneThousandBill) +
                  parseFloat(fiveHundredBill) +
                  parseFloat(twoHundredBill) +
                  parseFloat(oneHundredBill) +
                  parseFloat(fiftyBill) +
                  parseFloat(twentyBill) +
                  parseFloat(twentyCoin) +
                  parseFloat(tenCoin) +
                  parseFloat(fiveCoin) +
                  parseFloat(oneCoin) +
                  parseFloat(fiftyCentsCoin) +
                  parseFloat(twentyfiveCentsCoin) +
                  parseFloat(tenCentsCoin) +
                  parseFloat(fiveCentsCoin) +
                  parseFloat(oneCentCoin)
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
            <Typography style={{ color: "green", fontWeight: "bold" }}>
              Total
            </Typography>
          </div>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Update & Confirm Cash Count
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DialogTeamLeaderUpdateCashCount;
